module.exports = __webpack_public_path__ + "img/csv.509e9348.svg";